import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {Button, Col, Form, InputNumber, Row, Select, Switch} from "antd";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

const {Option} = Select;

function Seniority(props) {
    const {t} = useTranslation();
    const [isSeniority, setIsSeniority] = useState(true);
    const [isMulti, setIsMulti] = useState(false)
    const [isMultiYear, setIsMultiYear] = useState(false)
    const [span, setSpan] = useState(8)
    const [ml, setML] = useState("ml-9")

    function onChangeSeniority() {
        setIsSeniority(!isSeniority);
    }

    const checkIfMultiLeaves = (values) => {
        if (values > 1) {
            setIsMulti(true)
        } else {
            setIsMulti(false)
        }
    }

    const checkIfMultiYears = (values) => {
        if (values > 1) {
            setIsMultiYear(true)
        } else {
            setIsMultiYear(false)
        }
    }


    const getSpanCol= () => {

        if (window.innerWidth >= 1690) {
            return 8
        }

        return 11
    }

    useEffect(() => {
        setSpan(getSpanCol())
        setML(returnMl())
        setIsSeniority(props.allowedSeniority)
    }, [props.allowedSeniority])
    function handleResize() {
        setSpan(getSpanCol());
        setML(returnMl())
    }

    window.addEventListener('resize', handleResize)

    const returnMl = () =>{
        if (window.innerWidth >= 1680) {
            return "ml-9"
        }
        else if (window.innerWidth >= 1536) {
            return "ml-8"
        }

        return "ml-6"
    }

    return (
        <div id={props.id}>
            <Row gutter={12} className={'px-4'}>
                <Col span={24}>
                    <div className={"flex__align--center"}>
                        <Form.Item
                            name={"allowedSeniority"}
                            valuePropName={"checked"}
                            initialValue={true}
                            className={"margin--0"}
                        >
                            <Switch onChange={onChangeSeniority}/>
                        </Form.Item>
                        <span className={"px-4"}>
                            {t("leave-setting.allowedSeniority")}
                        </span>
                    </div>
                </Col>
            </Row>
            {isSeniority && <div id="allowed-seniority">
                <Row gutter={12} className={"my-2 px-4"}>
                    <Col span={24}>
						<span className={"char--gray margin__y--10"}>
							{t("leave-setting.allowedSeniorityDetails")}
						</span>
                    </Col>
                </Row>
                <Row gutter={12}>
                    <Col span={1}/>
                    <Col span={15}>
                        <div className={'mb-2 mt-3'}>
                            {t("leave-setting.dayStartCountedSeniority")}
                        </div>
                    </Col>
                    <Col span={1}/>
                    <Col span={7} >
                        <div className={`mr-4 ${ml}`}>
                            <Form.Item
                                name={"dayStartSeniority"}
                                initialValue={"day start work"}
                            >
                                <Select placeholder={t("leave-setting.dayStartWork")}>
                                    <Option value={"day start work"}>{t("leave-setting.dayStartWork")}</Option>
                                    <Option value={"day first contract"}>{t("leave-setting.dayFirstContract")}</Option>
                                    <Option
                                        value={"day signed contract"}>{t("leave-setting.daySignedContract")}</Option>
                                </Select>
                            </Form.Item>
                        </div>
                    </Col>
                </Row>
                <Form.List name="onLeaveConfigSeniorities" initialValue={[{}]}>
                    {(fields, {add, remove}) => (
                        <>
                            {fields.map(({key, name, ...restField}) => (
                                <Row gutter={12}>
                                    <Col span={1}/>
                                    <Col span={span}>
                                        <Row gutter={12}>
											<span className="px-2.5 mt-1">
												{t("leaveSetting.cu")}
											</span>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "yearSeniority"]}
                                                initialValue={5}
                                            >
                                                <InputNumber onChange={checkIfMultiYears}/>
                                            </Form.Item>
                                            <span className="px-2.5 mt-1">
												{isMultiYear
                                                    ? t("leaveSetting.yearSeniorities")
                                                    : t("leaveSetting.yearSeniority")}
											</span>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "seniorityLeave"]}
                                                initialValue={1}
                                            >
                                                <InputNumber onChange={checkIfMultiLeaves}/>
                                            </Form.Item>
                                            <span className="px-2.5 mt-1">
												{isMulti
                                                    ? t("leaveSetting.seniorityLeaves")
                                                    : t("leaveSetting.seniorityLeave")}
											</span>
                                        </Row>
                                    </Col>
                                    <Col span={1}>
                                        <div className={'mt-1.5'}>
                                            <MinusCircleOutlined
                                                onClick={() => remove(name)}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            ))}
                            <Row gutter={12}>
                                <Col span={1}/>
                                <Col span={1}>
                                    <Form.Item>
                                        <Button
                                            type="dashed"
                                            onClick={() => add()}
                                            block
                                            icon={<PlusOutlined/>}
                                        ></Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                    )}
                </Form.List>
            </div>}
        </div>
    );
}

export default Seniority;
